import _ from 'lodash';

export const buildUniqueCodeFromAgencyObj = (agency) => {
  return agency ? [agency.code, agency.dealerIdentification].join('|') : null;
};

export const getAgencyCodeFromAgencyUniqueCodeStr = (uniqueCode) => {
  return uniqueCode ? uniqueCode.split('|')[0] : null;
};

export const getDealerIdentificationFromAgencyUniqueCodeStr = (uniqueCode) => {
  return uniqueCode ? uniqueCode.split('|')[1] : null;
};

export const getAgencyFromUniqueCodeStr = (agencies, uniqueCode) => {
  const agencyCode = getAgencyCodeFromAgencyUniqueCodeStr(uniqueCode);
  const dealerId = getDealerIdentificationFromAgencyUniqueCodeStr(uniqueCode);
  return _.find(agencies, {'code': agencyCode, 'dealerIdentification': dealerId});
};
